import { render, staticRenderFns } from "./TagsImport.vue?vue&type=template&id=6ed652e0&"
import script from "./TagsImport.vue?vue&type=script&lang=js&"
export * from "./TagsImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports